
export async function wait(waitTimer: number){
    const timerPromise = new Promise((resolve) => {
        setTimeout(resolve, waitTimer);
    });

    await timerPromise;
}


export function roundOffFigure(amount: number, fractionDigits: number): number {
    try {
      return parseFloat(amount.toFixed(fractionDigits));
    } catch (e) {
      console.log(e);
      console.log(`roundedFigure(): ${amount}, ${fractionDigits}`);
    }
    return amount;
  }


  ///const roundedAmount = roundOffFigure(amount, 2);